import Vue from 'vue'

Vue.directive('preventReClick', require('./prevent-re-click').default)
